module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEDSURBVEhL7dS/asJQHMXxbIqDIOjqUFFbOygUN6G+maurPkyLUnDxEfoC/hcHcaijrd8DuXApydUkZtIDH0Ju5Pzg3kTvkSTJY4J9AK3ruVL0r5HTx5/DFG1s0EPkZPABlR3QQQENzKD1X/8qiYfs8ArlCXOY8lSGVLCAPUDbFetMwoZUsYTWtV1viJ0WTvg/pIYVtD5GDpHzgi1UYthD6lhD6yNkcXWCyg17iP27T2hbL8ZVHrRd7zDPh1pwxVWut6UJ++C7+PbvdS0hNJfKn6HYb5dxs3ITe8jNy000ZABnuT6aOOVXR3/BqZUrR6RWrugzT61cKUOf+Q++oDO5+3jeGaahmAvuCzGZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-hammer/dark/24.png
// module id = 2126
// module chunks = 2